import getConfig from '@om-fe/core/utils/config';
import { EventPart } from '@om-fe/models';

export function hideTimeOnHalfTime(partInfo: string | undefined): boolean {
    const config = getConfig();
    const configHideTimeOnHalfTime: boolean | undefined = config.layout && config.layout.hideTimeOnHalfTime;

    return !!configHideTimeOnHalfTime && partInfo === EventPart.FootballMatchTimeHalfTimeId;
}

export const EventItemClassName = 'EventItem';
